import React, { Fragment, useCallback, useState } from 'react'
import AddItem from '../components/AddItem'
import PersonalKanban from '../components/kanban/PersonalKanban'
import TodoList from '../components/todos/TodoList'
import PageTemplate from './templates/PageTemplate'
import { FOCUS } from '../data/focus'
import LOG from '../logging/Logger'

const TodayView = ({
  scrollRef,
  textFilter,
  tagsFilter,
  showAll,
  getTodos,
  handleTodoDragEnd,
  decrypt,
  editTodoStatus,
  getRepeatPattern,
  getProjectNameForTodo,
  redirectToProject,
  getProjectsForAreas,
  clientId,
  createProject,
  getProjectById,
  editTodo,
  getAvailableTags,
  createTodo,
  deleteTodo,
  getAreas,
  getTagsFromTodo,
  cacheDragList,
  setInfo,
  setWarning,
  setError,
  getAreaById,
  createAttachment,
  deleteAttachment,
  editAttachment,
  downloadAttachment,
  getTodoAttachments,
  kanban
}) => {
  LOG.debug('Render: TodayPage: TodayView')

  const [currentTodos, setCurrentTodos] = useState()

  const checkCacheDragList = useCallback(
    (list, todos) => {
      setCurrentTodos(todos)
      cacheDragList(list, todos)
    },
    [cacheDragList]
  )

  return (
    <Fragment>
      <AddItem
        list={FOCUS.TODAY.id}
        createTodo={createTodo}
        todos={currentTodos}
        decrypt={decrypt}
        getRepeatPattern={getRepeatPattern}
        getProjectsForAreas={getProjectsForAreas}
        clientId={clientId}
        deleteTodo={deleteTodo}
        redirectToProject={redirectToProject}
        getProjectById={getProjectById}
        createProject={createProject}
        editTodo={editTodo}
        getAvailableTags={getAvailableTags}
        getAreas={getAreas}
        getTagsFromTodo={getTagsFromTodo}
        createAttachment={createAttachment}
        deleteAttachment={deleteAttachment}
        editAttachment={editAttachment}
        downloadAttachment={downloadAttachment}
        getTodoAttachments={getTodoAttachments}
      />
      <br />
      <br />
      {kanban && (
        <PersonalKanban
          scrollRef={scrollRef}
          getTodos={getTodos}
          handleTodoDragEnd={handleTodoDragEnd}
          decrypt={decrypt}
          getRepeatPattern={getRepeatPattern}
          getProjectsForAreas={getProjectsForAreas}
          clientId={clientId}
          createProject={createProject}
          deleteTodo={deleteTodo}
          redirectToProject={redirectToProject}
          getProjectById={getProjectById}
          editTodo={editTodo}
          getAvailableTags={getAvailableTags}
          getAreas={getAreas}
          editTodoStatus={editTodoStatus}
          getProjectNameForTodo={getProjectNameForTodo}
          getTagsFromTodo={getTagsFromTodo}
          cacheDragList={checkCacheDragList}
          setInfo={setInfo}
          setWarning={setWarning}
          setError={setError}
          getAreaById={getAreaById}
          createAttachment={createAttachment}
          deleteAttachment={deleteAttachment}
          editAttachment={editAttachment}
          downloadAttachment={downloadAttachment}
          getTodoAttachments={getTodoAttachments}
        />
      )}
      {!kanban && (
        <TodoList
          scrollRef={scrollRef}
          textFilter={textFilter}
          tagsFilter={tagsFilter}
          showAll={showAll}
          list={FOCUS.TODAY.id}
          showAdd={false}
          getTodos={getTodos}
          decrypt={decrypt}
          editTodoStatus={editTodoStatus}
          getRepeatPattern={getRepeatPattern}
          getProjectNameForTodo={getProjectNameForTodo}
          redirectToProject={redirectToProject}
          getProjectsForAreas={getProjectsForAreas}
          clientId={clientId}
          createProject={createProject}
          deleteTodo={deleteTodo}
          getProjectById={getProjectById}
          editTodo={editTodo}
          getAvailableTags={getAvailableTags}
          createTodo={createTodo}
          getAreas={getAreas}
          getTagsFromTodo={getTagsFromTodo}
          cacheDragList={checkCacheDragList}
          setInfo={setInfo}
          setWarning={setWarning}
          setError={setError}
          getAreaById={getAreaById}
          createAttachment={createAttachment}
          deleteAttachment={deleteAttachment}
          editAttachment={editAttachment}
          downloadAttachment={downloadAttachment}
          getTodoAttachments={getTodoAttachments}
        />
      )}
    </Fragment>
  )
}

export default props => {
  LOG.debug('Render: TodayPage')

  return (
    <PageTemplate list={FOCUS.TODAY.id} {...props}>
      <TodayView {...props} />
    </PageTemplate>
  )
}
